import i18next from "i18next";
import { cellWithTooltip, dateValueFormatter } from "../../../components/common/datatable/EADataGrid";
import DataTableActions from "../../../components/common/datatable/DataTableActions";
import React from "react";
import { PrivilegeEnum } from "../../../services/common/RolesUtils";
import { getCalculationTargetResourceTypeOptions } from "services/common/CalculatorUtils";

const calculationTableActions = (
  calculationId,
  active,
  openEditDialog,
  openReadDialog,
  openDeleteDialog,
  onToggleStatus,
  hasAnyOfPrivileges
) => {
  return [
    {
      label: i18next.t("read"),
      icon: "open-eye",
      action: () => openReadDialog(calculationId),
      isDisabled: !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_CALCULATION),
    },
    {
      label: i18next.t("modify"),
      icon: "edit_grey",
      action: () => openEditDialog(calculationId),
      isDisabled: !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_EDIT_CALCULATION_PARAMETERS),
    },
    {
      label: active ? i18next.t("rules.table.columns.actions.disable") : i18next.t("rules.table.columns.actions.enable"),
      icon: active ? "pause_circle_filled" : "play_circle_filled",
      action: () => { onToggleStatus(calculationId) },
      isDisabled: !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_EDIT_CALCULATION_STATUS),
    },
    {
      label: i18next.t("delete"),
      icon: "delete_grey",
      action: () => openDeleteDialog(calculationId),
      isDisabled: !hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_DELETE_CALCULATION),
    }
  ];
};

export const calculationListColumns = (openEditDialog, openReadDialog, openDeleteDialog, toggleStatus, hasAnyOfPrivileges) => {
  return [
    {
      field: "name",
      headerName: i18next.t("calculator.table.columns.name"),
      flex: 0.1,
      renderCell: (params) => cellWithTooltip(params.value),
    },
    {
      field: "nature",
      headerName: i18next.t("calculator.table.columns.nature"),
      flex: 0.1,
      renderCell: (params) => cellWithTooltip(params.value),
    },
    {
      field: "targetResourceType",
      headerName: i18next.t("calculator.table.columns.targetResourceType"),
      flex: 0.1,
      renderCell: (params) => {let options = getCalculationTargetResourceTypeOptions(params.value);
        let selectedOption = options.find(o => o.value === params.value);
        return selectedOption.label;
      },
    },
    {
      field: "executionMode",
      headerName: i18next.t("calculator.table.columns.executionMode"),
      flex: 0.1,
      renderCell: (params) => cellWithTooltip(params.value),
    },
    {
      field: "resultType",
      headerName: i18next.t("calculator.table.columns.resultType"),
      flex: 0.1,
      renderCell: (params) => cellWithTooltip(params.value),
    },
    {
      field: "user",
      headerName: i18next.t("calculator.table.columns.by"),
      flex: 0.1,
      renderCell: (params) => cellWithTooltip(params.value),
    },
    {
      field: "creationDate",
      headerName: i18next.t("calculator.table.columns.creationDate"),
      flex: 0.1,
      type: "date",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => dateValueFormatter(params),
    },
    {
      field: "description",
      headerName: i18next.t("calculator.table.columns.description"),
      flex: 0.1,
      renderCell: (params) => cellWithTooltip(params.value),
    },
    {
      field: "action",
      headerName: i18next.t("actions"),
      flex: 0.15,
      sortable: false,
      filterable: false,
      disableExport: true,
      hideSortIcons: true,
      disableReorder: true,
      disableColumnMenu: true,
      disableMultipleSelection: true,
      disableSelectionOnClick: true,
      isRowSelectable: false,
      hideFooterSelectedRowCount: true,
      align: "center",
      renderCell: (params) => {
        return (
          <div style={{ textAlign: "center" }}>
            <DataTableActions
              actions={calculationTableActions(
                params.row.id,
                params.row.enabled,
                openEditDialog,
                openReadDialog,
                openDeleteDialog,
                toggleStatus,
                hasAnyOfPrivileges
              )}
            />
          </div>
        );
      },
    },
  ];
};

export const FORM_ID = {
  create: "calculation-create-form-id",
  edit: "calculation-edit-form-id",
  delete: "calculation-delete-form-id",
};
